import { render, staticRenderFns } from "./GuessLike.vue?vue&type=template&id=6407558c&scoped=true"
import script from "./GuessLike.vue?vue&type=script&lang=js"
export * from "./GuessLike.vue?vue&type=script&lang=js"
import style0 from "./GuessLike.vue?vue&type=style&index=0&id=6407558c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6407558c",
  null
  
)

export default component.exports